/**
 * Применяет маску телефона к input элементу
 * Формат: +7 (XXX) XXX-XX-XX
 * 
 * @param {Event} e - Событие input
 */
export function applyPhoneMask(e) {
    const input = e.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    
    // Получаем только цифры
    let digits = input.value.replace(/\D/g, '');

    // Если начинается с 8, заменяем на 7
    if (digits.startsWith('8')) {
        digits = '7' + digits.slice(1);
    }

    // Если не начинается с 7 и есть цифры, добавляем 7
    if (digits && !digits.startsWith('7')) {
        digits = '7' + digits;
    }

    // Ограничиваем длину (7 + 10 цифр = 11)
    if (digits.length > 11) {
        digits = digits.slice(0, 11);
    }

    // Форматируем номер: +7 (XXX) XXX-XX-XX
    let formatted = '';
    if (digits.length > 0) {
        formatted = '+7';
        if (digits.length > 1) {
            const code = digits.slice(1, 4);
            formatted += ' (' + code;
            if (digits.length >= 4) {
                formatted += ') ' + digits.slice(4, 7);
            }
            if (digits.length >= 7) {
                formatted += '-' + digits.slice(7, 9);
            }
            if (digits.length >= 9) {
                formatted += '-' + digits.slice(9, 11);
            }
        }
    }

    // Устанавливаем новое значение
    input.value = formatted;

    // Вычисляем новую позицию курсора
    let newCursorPosition = cursorPosition;
    
    // Подсчитываем количество цифр до курсора в старом значении
    let digitsBeforeCursor = 0;
    for (let i = 0; i < Math.min(cursorPosition, oldValue.length); i++) {
        if (/\d/.test(oldValue[i])) {
            digitsBeforeCursor++;
        }
    }
    
    // Находим позицию в новом отформатированном значении
    let digitCount = 0;
    newCursorPosition = formatted.length;
    for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) {
            digitCount++;
            if (digitCount === digitsBeforeCursor) {
                newCursorPosition = i + 1;
                break;
            }
        }
    }

    // Устанавливаем курсор
    input.setSelectionRange(newCursorPosition, newCursorPosition);
}
